import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { SendAchFormCore } from "./SendAchFormCore";

interface SendAchFormModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess?: () => void;
}

export function SendAchFormModal({ open, onOpenChange, onSuccess }: SendAchFormModalProps) {
  const [resetTrigger, setResetTrigger] = useState(false);

  const handleOpenChange = (newOpen: boolean) => {
    if (!newOpen && open) {
      // Modal is closing, trigger reset
      setResetTrigger((prev) => !prev);
    }
    onOpenChange(newOpen);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-2xl lg:max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Send ACH Form</DialogTitle>
        </DialogHeader>

        <SendAchFormCore
          includeFreightTemplate
          allowEditLienholder={true}
          allowEditCountryType={true}
          onSuccess={() => {
            onSuccess?.();
            onOpenChange(false);
          }}
          onCancel={() => onOpenChange(false)}
          resetTrigger={resetTrigger}
        />
      </DialogContent>
    </Dialog>
  );
}
